import { Provider } from '@repo/api-gw-sdk';
import type { Account } from '@repo/api-gw-sdk/src/models/Account';

import { useDAL } from '@/contexts/useDAL';
import type { BackupVault } from '@/data/vaults/backupVault';

import CopyableCode from '../shared/copyableCode';

export const KmsCopyablePolicy = ({
  backupVault,
}: {
  backupVault: BackupVault;
}) => {
  const dal = useDAL();
  const { data: restoreAccounts } = dal.cloudAccounts.restore.list();
  const { data: vaultAccounts } = dal.vaults.getAccounts();

  return (
    <CopyableCode
      title='policy.json'
      code={getCode(
        vaultAccounts?.accounts.filter(
          (a) => a.cloudProvider === backupVault.vaultAttributes.cloudProvider
        ),
        restoreAccounts?.accounts,
        backupVault.vaultAccountId
      )}
      maxHeight='320px'
    />
  );
};

const getCode = (
  vaultAccounts?: Account[],
  restoreAccounts?: Account[],
  vaultAccountId?: string
) => {
  return `
  {
    "Sid": "Allow key usage in vault account",
    "Effect": "Allow",
    "Principal": {
      "AWS": "arn:aws:iam::${vaultAccounts?.find((a) => a.id === vaultAccountId)?.providerAccountId || '<VaultAccountId>'}:root"
    },
    "Action": [
      "kms:Encrypt",
      "kms:Decrypt",
      "kms:GenerateDataKey"
    ],
    "Resource": "*"
  },
  {
    "Sid": "Allow key usage for restore node role and db query",
    "Effect": "Allow",
    "Principal": {
      "AWS": [${restoreAccounts
        ?.filter((x) => x.cloudProvider === Provider.Aws)
        .map(
          (a) =>
            `
        "arn:aws:iam::${a.providerAccountId}:role/EonRestoreAccountRole",
        "arn:aws:iam::${a.providerAccountId}:role/EonRestoreNodeRole"`
        )
        .join(',')}
      ]
    },
    "Action": [
      "kms:Encrypt",
      "kms:Decrypt",
      "kms:GenerateDataKey"
    ],
    "Resource": "*"
  }`;
};
